import React from 'react';
import styles from './MaintenancePage.module.css';

/**
 * MaintenancePage
 *
 * Standalone, zero-dependency maintenance page rendered BEFORE Azure Entra
 * authentication. Must not import any Nokia CCFK components, Redux, or MSAL
 * since those providers have not yet mounted.
 */
const MaintenancePage: React.FC = () => {
  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <div className={styles.imageWrapper}>
          <img
            src="/assets/images/Maintenance.svg"
            alt="Maintenance illustration"
            className={styles.illustration}
          />
        </div>

        <h1 className={styles.heading}>We are under maintenance</h1>

        <p className={styles.description}>
          We are currently performing scheduled maintenance. The application is
          temporarily unavailable. Please try again shortly.
        </p>

        <button
          className={styles.refreshButton}
          onClick={() => window.location.reload()}
          type="button"
        >
          Refresh
        </button>
      </div>
    </div>
  );
};

export default MaintenancePage;
